import React from "react";
import { Image, Platform } from "react-native";
import ToastContainerNative from "../toast/ToastContainer";
import * as IMAGES from "../../resources/IMAGES";

const ToastWrapper = () => {
  return (
    <>
      {Platform.OS == "web" && (
        <ToastContainerNative
          icon={() => {
            return (
              <Image
                resizeMode="contain"
                source={IMAGES.LOGO_TRANSPARENT}
                style={{ width: 20, height: 20 }}
              />
            );
          }}
        />
      )}
    </>
  );
};

export default ToastWrapper;
